import { render, staticRenderFns } from "./login-account.vue?vue&type=template&id=87c7d6cc&scoped=true&"
import script from "./login-account.vue?vue&type=script&lang=js&"
export * from "./login-account.vue?vue&type=script&lang=js&"
import style0 from "./login-account.vue?vue&type=style&index=0&id=87c7d6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c7d6cc",
  null
  
)

export default component.exports